import { useGetAllCountriesQuery } from 'generated/graphql'
import { ControlledMultiSelect } from 'components/ControlledFields'
import { CountryFlag } from 'components/CountryFlag'
import { FieldValues, FieldPath, UseFormReturn } from 'react-hook-form'
import { ICustomFieldComponentProps } from 'types'

type CountryMultiSelectProps<T extends FieldValues> =
  ICustomFieldComponentProps<
    T,
    FieldPath<T>,
    {
      onChange?: (values: string[], methods: UseFormReturn<T>) => void
    }
  >

export const CountryMultiSelect = <T extends FieldValues>({
  name,
  label,
  placeholder,
  disabled,
  onChange
}: CountryMultiSelectProps<T>) => {
  const { data, loading } = useGetAllCountriesQuery()

  const options =
    data?.countries?.map(country => ({
      value: country.alpha2,
      label: (
        <span className="flex items-center gap-2">
          <CountryFlag alpha2={country.alpha2} />
          {country.name}
        </span>
      ),
      searchLabel: country.name
    })) ?? []

  return (
    <ControlledMultiSelect
      name={name}
      label={label}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      isLoading={loading}
      onChange={onChange}
    />
  )
}
